import { Input } from '@ds';
import { AdminFormRow, ConditionalRender } from '@ui';
import { TrackedLocation } from '@/api/apis/resources';
import { formatDate } from '@/utils/helpers';

type LocationTrackingInfoProps = {
  trackedLocation?: TrackedLocation;
};

export const LocationTrackingInfo = ({ trackedLocation }: LocationTrackingInfoProps) => {
  return (
    <>
      <AdminFormRow title="Current Location">
        <Input
          aria-label="Current Location"
          type="text"
          isReadOnly
          isDisabled
          value={trackedLocation?.address ?? 'Location not available'}
        />
      </AdminFormRow>
      <ConditionalRender show={!!trackedLocation?.address}>
        <AdminFormRow title="Location Tracked">
          <Input
            aria-label="Location Tracked"
            type="text"
            isReadOnly
            isDisabled
            value={formatDate(trackedLocation?.trackedTime, 'MM/dd/yyyy, HH:mm zzz')}
          />
        </AdminFormRow>
      </ConditionalRender>
    </>
  );
};
